export default __webpack_public_path__ + "alberta-fab-checkbox-on.bb00836f886f20ab85e8.svg";